export default __webpack_public_path__ + "paper-clip-outline.png";